import dayjs from "dayjs";
import { defineStore } from "pinia";
export const useAnalyticsStore = defineStore("Analytics", {
  state: () => ({
    selectedDateRange: [dayjs().subtract(1, "week").toDate(), dayjs().endOf("day").toDate()] as Date[],
  }),
  getters: {
    getSelectedDateRange(): Date[] {
      return this.selectedDateRange;
    },
  },
  actions: {},
});
